var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserServiceManaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M95.897 89.397c-18.199 0-32.948-14.75-32.948-32.949 0-18.198 14.75-32.948 32.948-32.948 18.199 0 32.949 14.75 32.949 32.948 0 18.2-14.75 32.949-32.949 32.949",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#b5c7cd",
      fillOpacity: 1,
      strokeWidth: 1.64743,
      strokeMiterlimit: 10
    },
    d: "M95.076 102.576c-1.487 0-2.946.04-4.377.115v.055c-43.764 2.779-60.494 40.065-60.494 40.065L30 168.473h77.459l33.035-29.73-10.84-10.755a6.598 6.598 0 0 1 0-9.383l4.848-4.81c-8.835-5.664-20.12-10.153-34.229-11.049v-.055a82.579 82.579 0 0 0-4.377-.115c-.138 0-.272.005-.41.006-.137 0-.272-.006-.41-.006zm54.537 45.213L131 168.473h29.973l-.08-10.077a6.66 6.66 0 0 1-1.918-1.32l-9.362-9.287z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ad3f16",
    d: "m114.31 182.065 35.612-39.569-4.421-4.42-39.57 35.61a5.931 5.931 0 1 0 8.38 8.38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#751b0b",
    d: "m178.745 135.95-26.607-26.61-16.739 16.733 26.606 26.61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6742d",
    d: "m157.666 148.28 16.742-16.742a3.073 3.073 0 0 0 0-4.346l-13.475-13.472a3.073 3.073 0 0 0-4.346 0l-16.739 16.742a3.073 3.073 0 0 0 0 4.346l13.472 13.472a3.073 3.073 0 0 0 4.346 0zm-22.204-22.276 16.67-16.667a3.126 3.126 0 1 0-4.42-4.421l-16.668 16.667a3.126 3.126 0 0 0 4.42 4.42zm30.952 30.95 16.67-16.668a3.126 3.126 0 1 0-4.42-4.421l-16.668 16.667a3.126 3.126 0 1 0 4.42 4.421z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserServiceManaged);
export default __webpack_public_path__ + "static/media/userServiceManaged.472fcf840f1e58c5253b654a6a401c08.svg";
export { ForwardRef as ReactComponent };